import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import DueDate from './DueDate.js'
import { BoldFormTitle } from '../styles/Text.js'
import { PrimaryColorDivider, FlexColumn } from '../styles/Containers.js'

function DueDateList({ dueDates = [], onUpdateDueDates = () => {} }) {
  const [dueDateList, setDueDateList] = useState(dueDates)

  useEffect(() => {
    setDueDateList(dueDates)
  }, [dueDates])

  function handleUpdateDueDate(updatedDate) {
    const updatedDateList = dueDateList.map(d => (d.id === updatedDate.id ? updatedDate : d))
    setDueDateList(updatedDateList)
    onUpdateDueDates(updatedDateList)
  }

  return (
    <FlexColumn gap="15px">
      <BoldFormTitle>Due Dates</BoldFormTitle>
      <PrimaryColorDivider />
      {dueDateList &&
        dueDateList.length > 0 &&
        dueDateList.map(dueDate => (
          <DueDate key={dueDate.id} dueDate={dueDate.dueDate} dueDateId={dueDate.id} daysLeft={dueDate.daysLeft} onEdit={handleUpdateDueDate} />
        ))}
    </FlexColumn>
  )
}

DueDateList.propTypes = {
  dueDates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      dueDate: PropTypes.instanceOf(Date).isRequired
    })
  ),
  onUpdateDueDates: PropTypes.func
}

export default DueDateList
